import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Team from "./pages/About/Team";
import Blogs from "./pages/Blogs/Blogs";
import Contact from "./pages/Contact/Contact";
import News from "./pages/News/News";
import ScrollToTop from "./ScrollToTop";
import LoginStudent from "./pages/Login/student/LoginStudent";
import Innovation from "./pages/innovations/Innovation";
import StudentContainer from "./containers/StudentContainer";
import Faqs from "./pages/FAQ/Faqs";
import Internships from "./pages/internships/Internships";
import PodcastList from "./pages/podcasts/Podcasts";
import Talks from "./pages/talks/Talks";
import StudentProfile from "./pages/profile/student/StudentProfile";
import IndutryUserContainer from "./containers/IndustryUser";
import IndustryProfile from "./pages/profile/industry/IndustryProfile";
import PostInternship from "./pages/profile/industry/PostInternship";
import AddIndustryEvents from "./pages/profile/industry/AddIndustryEvents";
import IndustryAdvertise from "./pages/profile/industry/IndustryAdvertise";
import AddIndustryNews from "./pages/profile/industry/AddIndustryNews";
import AddIndustryBlogs from "./pages/profile/industry/AddIndustryBlogs";
import IndustryFeedback from "./pages/profile/industry/IndustryFeedback";
import BlogDetails from "./pages/Blogs/BlogDetails";
import Events from "./pages/Events/Events";
import PostIndustryJobs from "./pages/profile/industry/PostIndustryJobs";
import TotalStudents from "./pages/superadmin/studentdata/TotalStudents";
import AdminContainer from "./containers/AdminContainer";
import HomeContainer from "./containers/HomeContainer";
import AddIndustryPodcast from "./pages/profile/industry/AddIndustryPodcast";
import Dashoboard from "./pages/superadmin/Dashoboard";
import EventsFromIndustry from "./pages/superadmin/industryData/EventsFromIndustry";
import PodcastFromIndustry from "./pages/superadmin/industryData/PodcastFromIndustry";
import NewsFromIndustry from "./pages/superadmin/industryData/NewsFromIndustry";
import BlogsFromIndustry from "./pages/superadmin/industryData/BlogsFromIndustry";
import TotalIndustryUsers from "./pages/superadmin/industryData/TotalIndustryUsers";
import FeedbacksFromIndustry from "./pages/superadmin/industryData/FeedbacksFromIndustry";
import SuperadminLogin from "./pages/superadmin/SuperadminLogin";
import TalksFromIndustry from "./pages/superadmin/industryData/TalksFromIndustry";
import Polls from "./pages/polls/Polls";
import Merchants from "./pages/merchants/Merchants";
import MerchantsDetails from "./pages/merchants/MerchantsDetails";
import AddIndustryInnovation from "./pages/profile/industry/AddIndustryInnovation";
import Resume from "./pages/profile/student/Resume";
import CompleteProfile from "./pages/profile/industry/CompleteProfile";
import ManageUsers from "./pages/superadmin/ManageUser";
import MerchantsBusinesslist from "./pages/superadmin/merchants/MerchantsBusinesslist";
import Jobs from "./pages/jobs/Jobs";
import TotalMerchants from "./pages/superadmin/merchants/TotalMerchants";
import InternshipDetails from "./pages/internships/InternshipDetails";
import StudentFeedback from "./pages/profile/student/StudentFeedback";
import EventDetail from "./pages/Events/EventDetail";
import TalkDetail from "./pages/talks/TalkDetail";
import AddBusiness from "./pages/profile/merchant/AddBusiness";
import MerchantDetail from "./pages/superadmin/merchants/MerchantDetail";
import InternshipsFromIndustry from "./pages/superadmin/industryData/InternshipsFromIndustry";
import JobsFromIndustry from "./pages/superadmin/industryData/JobsFromIndustry";
import Bookmark from "./pages/profile/student/Bookmark";
import JobDetail from "./pages/jobs/JobDetail";
import BecomeAmbassador from "./pages/profile/student/BecomeAmbassador";
import TotalJobApplications from "./pages/superadmin/studentdata/TotalJobApplications";
import BecomeAmbassadorData from "./pages/superadmin/studentdata/BecomeAmbassadorData";
import TotalInternshipApplication from "./pages/superadmin/studentdata/TotalInternshipApplication";
import ContactFormEntries from "./pages/superadmin/ContactFormEntries";
import AddIndustryPolls from "./pages/profile/industry/AddIndustryPolls";
import MyNetwork from "./pages/profile/student/MyNetwork";
import InternalContainer from "./containers/InternalContainer";
import InternalLogin from "./pages/InternalManagement/InternalLogin/InternalLogin";
import AddInternalBlogs from "./pages/InternalManagement/AddInternalBlogs";
import AddInternalEvents from "./pages/InternalManagement/AddInternalEvents";
import AddInternalNews from "./pages/InternalManagement/AddInternalNews";
import AddInternalPodcasts from "./pages/InternalManagement/AddInternalPodcasts";
import AddInternalPolls from "./pages/InternalManagement/AddInternalPolls";
import AddInternalTalks from "./pages/InternalManagement/AddInternalTalks";
import InternalDashboard from "./pages/InternalManagement/InternalDashboard";
import AddInternalMerchants from "./pages/InternalManagement/AddInternalMerchants";
import AddYuvasarthiBlogs from "./pages/superadmin/AddYuvasarthiBlogs";
import AddYuvasarthiTalks from "./pages/superadmin/AddYuvasarthiTalks";
import AddYuvasarthiNews from "./pages/superadmin/AddYuvasarthiNews";
import AddYuvasarthiEvents from "./pages/superadmin/AddYuvasarthiEvents";
import AddYuvasarthiPolls from "./pages/superadmin/AddYuvasarthiPolls";
import AddYuvasarthiPodcasts from "./pages/superadmin/AddYuvasarthiPodcasts";
import PostYuvasarthiInternships from "./pages/superadmin/PostYuvasarthiInternships";
import PostYuvasarthiJobs from "./pages/superadmin/PostYuvasarthiJobs";
import { ToastContainer } from "react-toastify";
import { ToastConfig } from "./config";
import QuickLook from "./quicklook/QuickLook";
import EditStudentProfile from "./pages/profile/student/EditStudentProfile";
import OrganizationLogin from "./pages/Login/industry/OrganizationLogin";
import StudentRegister from "./pages/register/StudentRegister";
import IndustryRegister from "./pages/register/IndustryRegister";
import AddSlider from "./Administrative/AddSlider";
import PostInternships from "./pages/profile/industry/PostInternship";
import AdvertisementsFromIndustry from "./pages/superadmin/industryData/AvertisementsFromIndustry";
import AddIndustryTalks from "./pages/profile/industry/AddIndustryTalks";
import PollsFromIndustry from "./pages/superadmin/industryData/PollsFromIndustry";
import InnovativeIdeasFromIndustry from "./pages/superadmin/industryData/InnovativeIdeasFromIndustry";
import ForgetStudentPassword from "./pages/Login/student/ForgetStudentPassword";
import NewStudentPass from "./pages/Login/student/NewStudentPass";
import AmbassadorEntries from "./pages/profile/student/AmbassadorEntries";
import FeedbackFromStudents from "./pages/superadmin/studentdata/FeedbackFromStudents";
import ForgetIndustryPassword from "./pages/Login/industry/ForgetIndustryPassword";
import NewIndustryPassword from "./pages/Login/industry/NewIndustryPassword";
import StudentInternshipApplications from "./pages/profile/student/StudentInternshipApplications";
import IndustryBusinessEntries from "./pages/superadmin/industryData/IndustryBusinessEntries";
import MerchantRegister from "./pages/register/MerchantRegister";
import LoginMerchant from "./pages/Login/merchant/LoginMerchant";
import IndustryInternshipApplications from "./pages/profile/industry/IndustryInternshipApplications";
import IndustryJobApplications from "./pages/profile/industry/IndustryJobApplication";
import InternshipApplicationPosition from "./pages/profile/industry/InternshipApplicationsPosition";
import IndustryInternshipDetails from "./pages/internships/IndustryInternshipDetail";
import IndustryJobDetails from "./pages/jobs/IndustryJobDetails";
import StudentJobApplications from "./pages/profile/student/StudentJobApplications";
import InternshipApplications from "./pages/superadmin/industryData/InternshipApplications";
import JobApplications from "./pages/superadmin/industryData/JobApplications";
import StudentEnquiries from "./pages/profile/student/StudentEnquiries";
import MerchantContainer from "./containers/MerchantContainer";
import Merchantprofile from "./pages/profile/merchant/Merchantprofile";
import MerchantFeedback from "./pages/profile/merchant/MerchantFeedback";
import EditOrganizationDetails from "./pages/profile/industry/EditOrganizationDetails";
import EditIndustryProfile from "./pages/profile/industry/EditIndustryProfile";
import EditShopDetails from "./pages/profile/merchant/EditShopDetails";
import AddMerchantBusiness from "./pages/superadmin/merchants/AddMerchantBusiness";
import AdminMerchantDetails from "./pages/merchants/AdminMerchantDetail";
import AddOrganizationDetails from "./pages/superadmin/industryData/AddOrganizationDetails";
import ForgetMerchantPass from "./pages/Login/merchant/ForgetMerchantPass";
import NewMerchantPass from "./pages/Login/merchant/NewMerchantPass";
import TotalEnquiries from "./pages/profile/merchant/TotalEnquiries";
import MerchantsEnquiries from "./pages/superadmin/merchants/MerchantEnquiries";
import AdminEventDetail from "./pages/Events/AdminEventDetails";
import StudentEventEnquiries from "./pages/profile/student/StudentEventEnquiries";
import IndustryEventEntries from "./pages/profile/industry/IndustryEventEntries";
import EventEntries from "./pages/superadmin/industryData/EventEntries";
import YuvasarathiEventEnquiries from "./pages/superadmin/YuvasarathiEventEnquiries";
import AdminBlogDetails from "./pages/Blogs/AdminBlogDetails";
import NewsDetail from "./pages/News/NewsDetails";
import OrganizationDetails from "./pages/merchants/OrganizationDetails";
import PaymentRefund from "./pages/PaymentPages/PaymentRefund";
import PrivacyPolicy from "./pages/PaymentPages/PrivacyPolicy";
import DeliveryPolicy from "./pages/PaymentPages/DeliveryPolicy";
import EventRegistration from "./pages/Events/EventRegistration";
import AdminOrg_Details from "./pages/merchants/AdminOrg_Details";
import EventTicket from "./pages/Events/EventTicket";
import StudentShareIdea from "./pages/profile/student/StudentShareIdea";
import AllAmbassador from "./pages/profile/student/AllAmbassador";
import AllIndustryShareIdeas from "./pages/superadmin/industryData/AllIndustryShareIdeas";
import AddInternalInternships from "./pages/InternalManagement/AddInternalInternships";
import AddInternalJobs from "./pages/InternalManagement/AddInternalJobs";
import IdeasFromStudent from "./pages/profile/industry/IdeasFronStudent";
import MembershipRegistration from "./pages/membershipRegistration/MembershipRegistration";
import LoadingBar from "react-top-loading-bar";
import configContext from "./context/configContext/configContext";
import { useContext } from "react";
import Donation from "./pages/donation/Donation";
import Gallery from "./pages/gallery/Gallery";
import AddGallery from "./Administrative/AddGallery";
import AddPrograms from "./Administrative/AddPrograms";
import AddTestinomials from "./Administrative/AddTestinomials";
import ViewMembershipRegistrations from "./Administrative/ViewMembershipRegistrations";

function App() {
  const { progress, setProgress } = useContext(configContext);

  return (
    <>
      <ToastContainer {...ToastConfig} toastClassName="toast-homepage" />
      <LoadingBar
        color="#007bff"
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
        height="3px"
      />
      <ScrollToTop />
      <QuickLook />
      <Routes>
        <Route path="/" element={<HomeContainer />}>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/team" element={<Team />} />
          <Route exact path="/blogs" element={<Blogs />} />
          <Route exact path="/blogs/:id" element={<BlogDetails />} />
          <Route exact path="/adminblogs/:id" element={<AdminBlogDetails />} />
          <Route exact path="/news" element={<News />} />
          <Route exact path="/news/:id" element={<NewsDetail />} />
          <Route exact path="/polls" element={<Polls />} />
          <Route exact path="/donation" element={<Donation />} />
          <Route exact path="/gallery" element={<Gallery />} />
          <Route
            exact
            path="/membership"
            element={<MembershipRegistration />}
          />
          <Route exact path="/events" element={<Events />} />
          <Route exact path="/events/:id" element={<EventDetail />} />
          <Route exact path="/adminevents/:id" element={<AdminEventDetail />} />
          <Route
            exact
            path="/organization/:id"
            element={<OrganizationDetails />}
          />
          <Route
            exact
            path="/adminorganization/:id"
            element={<AdminOrg_Details />}
          />
          <Route exact path="/studentregister" element={<StudentRegister />} />
          <Route
            exact
            path="/industryregister"
            element={<IndustryRegister />}
          />
          <Route
            exact
            path="/merchantregister"
            element={<MerchantRegister />}
          />
          <Route exact path="/faqs" element={<Faqs />} />

          <Route exact path="/innovations" element={<Innovation />} />
          <Route exact path="/loginstudent" element={<LoginStudent />} />
          <Route exact path="/loginorg" element={<OrganizationLogin />} />
          <Route exact path="/loginmerchant" element={<LoginMerchant />} />
          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/podcast" element={<PodcastList />} />
          <Route exact path="/talks" element={<Talks />} />
          <Route exact path="/talks/:id" element={<TalkDetail />} />
          <Route exact path="/internships" element={<Internships />} />
          <Route
            exact
            path="/internships/:id"
            element={<InternshipDetails />}
          />
          <Route
            exact
            path="/industryinternships/:id"
            element={<IndustryInternshipDetails />}
          />
          <Route exact path="/jobs" element={<Jobs />} />
          <Route exact path="/jobs/:id" element={<JobDetail />} />
          <Route
            exact
            path="/industryjobs/:id"
            element={<IndustryJobDetails />}
          />
          <Route
            exact
            path="/loginstudent/forgetpassword"
            element={<ForgetStudentPassword />}
          />
          <Route
            exact
            path="/loginstudent/newpassword"
            element={<NewStudentPass />}
          />
          <Route
            exact
            path="/loginorg/forgetpassword"
            element={<ForgetIndustryPassword />}
          />
          <Route
            exact
            path="/loginorg/newpassword"
            element={<NewIndustryPassword />}
          />
          <Route
            exact
            path="/loginmerchant/forgetpassword"
            element={<ForgetMerchantPass />}
          />
          <Route
            exact
            path="/loginmerchant/newpassword"
            element={<NewMerchantPass />}
          />
          <Route exact path="/merchants" element={<Merchants />} />
          <Route exact path="/merchants/:id" element={<MerchantsDetails />} />
          <Route
            exact
            path="/adminmerchants/:id"
            element={<AdminMerchantDetails />}
          />
          <Route exact path="/refund" element={<PaymentRefund />} />
          <Route exact path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route exact path="/deliverypolicy" element={<DeliveryPolicy />} />
          <Route
            exact
            path="/eventregistration"
            element={<EventRegistration />}
          />
          <Route exact path="/ticket" element={<EventTicket />} />
          {/* <Route path='/resume' element={<Resume />} /> */}
        </Route>

        <Route path="/industryprofile" element={<IndutryUserContainer />}>
          <Route index element={<IndustryProfile />} />
          <Route path="postinternships" element={<PostInternships />} />
          <Route path="addindustryevents" element={<AddIndustryEvents />} />
          <Route path="industryadvertise" element={<IndustryAdvertise />} />
          <Route path="industrynews" element={<AddIndustryNews />} />
          <Route path="industryblogs" element={<AddIndustryBlogs />} />
          <Route path="industryfeedbacks" element={<IndustryFeedback />} />
          <Route path="postjobs" element={<PostIndustryJobs />} />
          <Route
            path="editorganization"
            element={<EditOrganizationDetails />}
          />
          <Route path="editindustryprofile" element={<EditIndustryProfile />} />
          <Route
            path="industrychallenges"
            element={<AddIndustryInnovation />}
          />
          <Route path="industrypodcast" element={<AddIndustryPodcast />} />
          <Route path="addbusiness" element={<AddBusiness />} />
          <Route path="completeindustryprofile" element={<CompleteProfile />} />
          <Route path="industrypolls" element={<AddIndustryPolls />} />
          <Route path="industrytalks" element={<AddIndustryTalks />} />
          <Route
            path="studentinternshipapplications"
            element={<IndustryInternshipApplications />}
          />
          <Route
            path="studentjobpapplications"
            element={<IndustryJobApplications />}
          />
          <Route
            path="positions-internship"
            element={<InternshipApplicationPosition />}
          />
          <Route path="evententries" element={<IndustryEventEntries />} />
          <Route path="ideasfromstudent" element={<IdeasFromStudent />} />
          <Route path="faqs" element={<Faqs />} />
        </Route>

        <Route path="/studentprofile" element={<StudentContainer />}>
          <Route index element={<StudentProfile />} />
          <Route path="editprofile" element={<EditStudentProfile />} />
          <Route path="becomeambassador" element={<BecomeAmbassador />} />
          <Route path="shareidea" element={<StudentShareIdea />} />
          <Route path="studentfeedback" element={<StudentFeedback />} />
          <Route path="bookmark" element={<Bookmark />} />
          <Route path="mynetwork" element={<MyNetwork />} />
          <Route path="resume" element={<Resume />} />
          <Route path="ambassadorentry" element={<AmbassadorEntries />} />
          <Route
            path="myapplications"
            element={<StudentInternshipApplications />}
          />
          <Route
            path="myjobapplications"
            element={<StudentJobApplications />}
          />
          <Route path="myenquiries" element={<StudentEnquiries />} />
          <Route path="myeventenquiries" element={<StudentEventEnquiries />} />
          <Route path="allambassador" element={<AllAmbassador />} />
          <Route path="faqs" element={<Faqs />} />
        </Route>

        <Route path="/merchantprofile" element={<MerchantContainer />}>
          <Route index element={<Merchantprofile />} />
          <Route path="addbusiness" element={<AddBusiness />} />
          <Route path="merchantfeedback" element={<MerchantFeedback />} />
          <Route path="totalenquiries" element={<TotalEnquiries />} />
          <Route path="editshopdetails" element={<EditShopDetails />} />
        </Route>

        <Route path="/superadmin" element={<SuperadminLogin />} />
        <Route path="/superadmin" element={<AdminContainer />}>
          {/* yuvasarthi */}
          <Route exact path="manageuser" element={<ManageUsers />} />
          <Route exact path="dashboard" element={<Dashoboard />} />
          <Route exact path="addevents" element={<AddYuvasarthiEvents />} />
          <Route exact path="addpodcasts" element={<AddYuvasarthiPodcasts />} />
          <Route exact path="addnews" element={<AddYuvasarthiNews />} />
          <Route exact path="addtalks" element={<AddYuvasarthiTalks />} />
          <Route exact path="addblogs" element={<AddYuvasarthiBlogs />} />
          <Route exact path="addgallery" element={<AddGallery />} />
          <Route exact path="addprograms" element={<AddPrograms />} />
          <Route
            exact
            path="membershipregistrations"
            element={<ViewMembershipRegistrations />}
          />
          <Route exact path="addtestimonials" element={<AddTestinomials />} />
          <Route
            exact
            path="postinternships"
            element={<PostYuvasarthiInternships />}
          />
          <Route exact path="postjobs" element={<PostYuvasarthiJobs />} />
          <Route exact path="contactentries" element={<ContactFormEntries />} />
          <Route exact path="addpolls" element={<AddYuvasarthiPolls />} />
          <Route exact path="addslider" element={<AddSlider />} />
          <Route
            exact
            path="advertisementfromindustry"
            element={<AdvertisementsFromIndustry />}
          />
          <Route
            exact
            path="studentfeedbacks"
            element={<FeedbackFromStudents />}
          />
          <Route
            exact
            path="yuvasarathieventenquiries"
            element={<YuvasarathiEventEnquiries />}
          />

          {/* Students */}
          <Route exact path="students" element={<TotalStudents />} />
          <Route
            exact
            path="becomeambassador"
            element={<BecomeAmbassadorData />}
          />
          <Route
            exact
            path="totaljobapplications"
            element={<TotalJobApplications />}
          />
          <Route
            exact
            path="totalinternshipapplications"
            element={<TotalInternshipApplication />}
          />

          {/* industry */}
          <Route
            exact
            path="addorganizationdetails"
            element={<AddOrganizationDetails />}
          />
          <Route
            exact
            path="eventsfromindustry"
            element={<EventsFromIndustry />}
          />
          <Route
            exact
            path="organizationentries"
            element={<IndustryBusinessEntries />}
          />
          <Route
            exact
            path="internshipsfromindustry"
            element={<InternshipsFromIndustry />}
          />
          <Route exact path="jobsfromindustry" element={<JobsFromIndustry />} />
          <Route
            exact
            path="podcastfromindustry"
            element={<PodcastFromIndustry />}
          />
          <Route exact path="newsfromindustry" element={<NewsFromIndustry />} />
          <Route
            exact
            path="blogsfromindustry"
            element={<BlogsFromIndustry />}
          />
          <Route
            exact
            path="totalindustryusers"
            element={<TotalIndustryUsers />}
          />
          <Route
            exact
            path="feedbacksfromindustryusers"
            element={<FeedbacksFromIndustry />}
          />
          <Route
            exact
            path="talksfromindustry"
            element={<TalksFromIndustry />}
          />
          <Route
            exact
            path="pollsfromindustry"
            element={<PollsFromIndustry />}
          />
          <Route
            exact
            path="ideasfromindustry"
            element={<InnovativeIdeasFromIndustry />}
          />
          <Route
            exact
            path="internshipapplications"
            element={<InternshipApplications />}
          />
          <Route exact path="jobapplications" element={<JobApplications />} />
          <Route
            exact
            path="ideasfromindustry"
            element={<InnovativeIdeasFromIndustry />}
          />
          <Route exact path="industryevententries" element={<EventEntries />} />
          <Route
            exact
            path="allshareideas"
            element={<AllIndustryShareIdeas />}
          />

          {/* merchants */}
          <Route
            exact
            path="merchantslist"
            element={<MerchantsBusinesslist />}
          />
          <Route exact path="addmerchant" element={<AddMerchantBusiness />} />
          <Route exact path="totalmerchants" element={<TotalMerchants />} />
          <Route exact path="totalmerchants/:id" element={<MerchantDetail />} />
          <Route
            exact
            path="merchantenquiries"
            element={<MerchantsEnquiries />}
          />
        </Route>

        {/* internal Management Login */}
        <Route path="/internaluser" element={<InternalLogin />} />
        <Route path="/internaluser" element={<InternalContainer />}>
          <Route
            exact
            path="internaldashboard"
            element={<InternalDashboard />}
          />
          <Route exact path="internalblogs" element={<AddInternalBlogs />} />
          <Route exact path="internalevents" element={<AddInternalEvents />} />
          <Route exact path="internalnews" element={<AddInternalNews />} />
          <Route
            exact
            path="internalpodcast"
            element={<AddInternalPodcasts />}
          />
          <Route exact path="internalpolls" element={<AddInternalPolls />} />
          <Route exact path="internaltalks" element={<AddInternalTalks />} />
          <Route
            exact
            path="internaladdmerchant"
            element={<AddInternalMerchants />}
          />
          <Route
            exact
            path="internaladdinternships"
            element={<AddInternalInternships />}
          />
          <Route exact path="internaladdjobs" element={<AddInternalJobs />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
